import { createRoot } from 'react-dom/client';
import html2canvas from 'html2canvas';
import RifaFlyerCompartir from '../components/RifaFlyerCompartir';
import { prepararRifaParaFlyer } from './imagenesFlyer';

/** Espera a que carguen imágenes del flyer (logo + premios). */
function esperarImagenes(contenedor, ms = 10000) {
  const imgs = contenedor.querySelectorAll('img');
  const promesas = [...imgs].map(
    (img) =>
      new Promise((resolve) => {
        const listo = () => resolve();
        if (img.complete && img.naturalWidth > 0) {
          listo();
          return;
        }
        img.onload = listo;
        img.onerror = listo;
      })
  );
  return Promise.race([
    Promise.all(promesas),
    new Promise((r) => setTimeout(r, ms)),
  ]);
}

/**
 * Genera un PNG del flyer de la rifa para compartir en WhatsApp.
 * @returns {Promise<Blob>}
 */
export async function generarImagenCompartirRifa(rifa, ganadores = []) {
  const rifaFlyer = await prepararRifaParaFlyer(rifa);

  const wrapper = document.createElement('div');
  wrapper.style.cssText =
    'position:fixed;left:-9999px;top:0;z-index:-1;pointer-events:none;';
  document.body.appendChild(wrapper);

  const root = createRoot(wrapper);

  root.render(<RifaFlyerCompartir rifa={rifaFlyer} ganadores={ganadores} />);

  await new Promise((r) => requestAnimationFrame(() => setTimeout(r, 100)));

  const target = wrapper.firstElementChild;
  if (!target) {
    root.unmount();
    document.body.removeChild(wrapper);
    throw new Error('No se pudo renderizar el flyer');
  }

  await esperarImagenes(target);

  const canvas = await html2canvas(target, {
    scale: 2,
    useCORS: false,
    backgroundColor: '#ececec',
    logging: false,
  });

  root.unmount();
  document.body.removeChild(wrapper);

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error('Error al crear imagen'))),
      'image/png',
      0.92
    );
  });
}

/** Descarga el PNG del flyer (sin abrir el menú de compartir del navegador). */
export async function descargarOCompartirImagenRifa(blob, rifa) {
  const nombre = `rifa-${(rifa.titulo || 'acceso7').replace(/[^\w\s-]/g, '').slice(0, 40)}.png`;
  const rifaUrl = `${window.location.origin}/rifa/${rifa.id}`;
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombre;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 2000);
  return { metodo: 'download', url: rifaUrl, nombre };
}
